import { useState } from "react";
import { Icon, Modal } from "components/ui";
import Portal from "components/Portal";
import { useSessionDetails } from "hooks/sessionDetails";
import { useApi } from "hooks/api";

export default function SessionDetailsPrompt(): JSX.Element {
  const {
    sessionId,
    sessionDetailsModal,
    setSessionDetailsModal,
    sessionDetails,
    setSessionDetails,
  } = useSessionDetails();
  const { logUsage } = useApi();
  const [username, setUsername] = useState(sessionDetails?.username || "");
  const [email, setEmail] = useState(sessionDetails?.email || "");

  return (
    <Portal>
      <Modal
        active={sessionDetailsModal.open}
        onClose={() => setSessionDetailsModal({ open: false })}
        className="session-details-prompt"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const details = { username, email };
            setSessionDetails(details);
            logUsage({
              sessionId,
              sessionDetails: details,
              // @ts-ignore
              media: sessionDetailsModal.media,
            });
            setSessionDetailsModal({ open: false });
          }}
        >
          <p>
            <Icon name={"clipboard-list"} />
            You need to enter your name and email to continue. These details are
            required for keeping track of usage of the selected asset. You may
            be contacted if the rights of usage for this asset changes.
          </p>
          <div className="input-group">
            <label>Name</label>
            <input
              name="eventusername"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus={true}
              required={true}
            />
            <Icon name={"user"} />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input
              name="eventuseremail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required={true}
            />
            <Icon name={"envelope"} />
          </div>
          <input type="submit" className="button" value="Continue" />
        </form>
      </Modal>
    </Portal>
  );
}
